export interface RouteStop {
  destinationId?: string;
  name: string;
  subtitle?: string;
  coords: [number, number]; // [lat, lon]
  description?: string;
  isMainDestination?: boolean;
}

export interface Route {
  id: string;
  day: number;
  title: string;
  subtitle: string;
  image: string;
  distanceKm: number;
  estimatedTime: string;
  elevationGainM: number;
  elevationLossM: number;
  color: string;
  mapUrl: string;
  locationIds: string[];
  waypoints: [number, number][]; // [lat, lon] pro Routing API
  stops: RouteStop[];
}

export const routes: Route[] = [
  {
    id: 'day1',
    day: 1,
    title: '1. den: Z Elektra do Severogradu',
    subtitle: 'Elektro → Pusta → Hrad Blansko → Kabanino → Grišino → Safezone Jílové',
    image: '/images/destinations/elektro.webp',
    distanceKm: 19.8,
    estimatedTime: '6:49 hod',
    elevationGainM: 713,
    elevationLossM: 594,
    color: '#0596ff',
    mapUrl: 'https://mapy.com/s/namomasuvo',
    locationIds: ['elektro', 'pusta', 'devils_castle', 'kabanino', 'grishino', 'safezone'],
    waypoints: [
      [50.67127, 14.15809], // Elektro (Povrly)
      [50.68652, 14.13783], // Pusta (Mašovice)
      [50.70714, 14.10392], // Devil's Castle (Hrad Blansko)
      [50.72621, 14.07724], // Kabanino (Mnichov)
      [50.73031, 14.09081], // Grishino (Čermná)
      [50.76077, 14.10398], // Safezone (Jílové)
    ],
    stops: [
      {
        destinationId: 'elektro',
        name: 'Elektrozavodsk (Povrly)',
        subtitle: 'Start 1. dne',
        coords: [50.67127, 14.15809],
        description: 'Výchozí bod u Labe. Parkování v Mírové a doplňování vody.',
        isMainDestination: true,
      },
      {
        destinationId: 'pusta',
        name: 'Pusta (Mašovice)',
        subtitle: 'První zastávka',
        coords: [50.68652, 14.13783],
        description: 'Vnitrozemská víska s dřevěnými stodolami a studnou.',
        isMainDestination: true,
      },
      {
        destinationId: 'devils_castle',
        name: "Devil's Castle (Hrad Blansko)",
        subtitle: 'Vyhlídka a oběd',
        coords: [50.70714, 14.10392],
        description: 'Zřícenina ve výšce 545 m n. m. 360° výhled a polední pauza.',
        isMainDestination: true,
      },
      {
        destinationId: 'kabanino',
        name: 'Kabanino (Mnichov)',
        subtitle: 'Vnitrozemská křižovatka',
        coords: [50.72621, 14.07724],
        description: 'Klíčová vesnice obklopená poli před přesunem na sever.',
        isMainDestination: true,
      },
      {
        destinationId: 'grishino',
        name: 'Grishino (Čermná)',
        subtitle: 'Severní podhůří',
        coords: [50.73031, 14.09081],
        description: 'Rybník a náves v podhůří Krušných hor.',
        isMainDestination: true,
      },
      {
        destinationId: 'safezone',
        name: 'Safezone (Northern Panorama Jílové)',
        subtitle: 'Cíl 1. dne',
        coords: [50.76077, 14.10398],
        description: 'Safezone apartmán v Jílovém. Ubytování, sprcha, regenerace.',
        isMainDestination: true,
      },
    ],
  },
  {
    id: 'day2',
    day: 2,
    title: '2. den: Ze Severogradu do Elektra',
    subtitle: 'Safezone Jílové → Grišino → Lesní hřeben / Slunečná → Ryjice → Elektro',
    image: '/images/destinations/severograd.webp',
    distanceKm: 17.8,
    estimatedTime: '5:49 hod',
    elevationGainM: 499,
    elevationLossM: 621,
    color: '#d97706',
    mapUrl: 'https://mapy.com/s/cocepapatu',
    locationIds: ['safezone', 'grishino', 'elektro'],
    waypoints: [
      [50.76077, 14.10398], // Safezone (Jílové)
      [50.73031, 14.09081], // Grishino (Čermná)
      [50.718, 14.135], // Vyhlídka Slunečná / lesní hřeben
      [50.692, 14.148], // Ryjice / Neštěmice vyhlídka
      [50.67127, 14.15809], // Elektro (Povrly)
    ],
    stops: [
      {
        destinationId: 'safezone',
        name: 'Safezone (Northern Panorama Jílové)',
        subtitle: 'Start 2. dne',
        coords: [50.76077, 14.10398],
        description: 'Ranní odchod po regeneraci a check-outu.',
        isMainDestination: true,
      },
      {
        destinationId: 'grishino',
        name: 'Grishino (Čermná)',
        subtitle: 'Průchozí bod',
        coords: [50.73031, 14.09081],
        description: 'Nástup na jižní hřebenovou turistickou stezku.',
        isMainDestination: true,
      },
      {
        name: 'Vyhlídka Slunečná / Hřeben',
        subtitle: 'Hřebenový úsek',
        coords: [50.718, 14.135],
        description: 'Lesní hřeben s vyhlídkami do krajiny České Středohoří.',
        isMainDestination: false,
      },
      {
        name: 'Ryjice / Neštěmické vyhlídky',
        subtitle: 'Vyhlídka nad Labem',
        coords: [50.692, 14.148],
        description: 'Panoramatický pohled na údolí řeky Labe a industriální pobřeží.',
        isMainDestination: false,
      },
      {
        destinationId: 'elektro',
        name: 'Elektrozavodsk (Povrly)',
        subtitle: 'Cíl expedice',
        coords: [50.67127, 14.15809],
        description: 'Návrat k autům v Mírové a slavnostní zakončení expedice.',
        isMainDestination: true,
      },
    ],
  },
];
